import { createFileRoute } from '@tanstack/react-router'

import { caseFilters } from '@/features/cases/case-filters'
import { CasesPage } from '@/features/cases/cases-page'

export const Route = createFileRoute('/_app/cases')({
    validateSearch: caseFilters.parse,
    component: CasesPage,
    staticData: { crumb: 'Cases' }
})
